import React from 'react';
import { Form, Icon as LegacyIcon } from '@ant-design/compatible';
import dayjs from "dayjs";
import {
    Modal,
    Input,
    InputNumber,
    Button,
    Row,
    Col,
    DatePicker,
    Popover,
    message,
    Tooltip,
} from 'antd';
import {
    dispensaries as dispensaryServices
} from '../../../services';
import { connect } from 'react-redux';
import {
    getPagePermissions,
    DISPENSARY_PERMISSION
} from '../../../security/permissions';
import tooltip from './tooltip.json';
import tooltipWarehouse from '../../wareHouse/components/tooltip.json';
import {InfoCircleFilled} from '@ant-design/icons';

const { TextArea } = Input;
const { confirm } = Modal;

const ContainerShowInfo = Form.create({ name: 'containerShowForm_into_modal' })(

    class extends React.Component {
        state = {
            container: {},
            visible: false,
            wasEdited: false,
            visibleEliminationFormContainer: false,
            edit: false,
            integrationCodeVS: {},
            integrationCodeExist: true,
            integrationCodeUpdated: '',
        };

        showModal = (idContainer) => {
            dispensaryServices.get(`container/${idContainer}`)
                .then(response => {
                    this.setState({
                        container: response,
                        visible: true,
                    });
                });
        }

        handleReturn = () => {
            this.setState({
                visible: false,
                wasEdited: false,
            });
            this.props.form.resetFields();
        };

        editFields = () => {
            this.setState({
                wasEdited: true,
            });
        }

        deleteContainer = (containerId) => {
            dispensaryServices.Delete(`container/delete/${containerId}`)
                .then(response => {
                    const jsonResponse = JSON.parse(JSON.stringify(response));
                    if (jsonResponse.hasOwnProperty('response')) {
                        message.error(jsonResponse.response.data);
                    } else {
                        this.props.onDeleteContainers();
                    }
                });
            this.setState({
                visible: false,
            });
        }

        editContainer = () => {
            this.props.form.validateFieldsAndScroll((err, values) => {
                if (!err) {
                    const { container } = this.state;
                    const filters = {
                        idContainer: container.idContainer,
                        containerDescription: values.containerDescription,
                        containerCalibrationDate: values.containerCalibrationDate !== null ? values.containerCalibrationDate.format('YYYY-MM-DD HH:mm:ss') : null,
                        integrationCode: values.integrationCode,
                        containerTotalCapacity: values.containerTotalCapacity,
                        containerMinOperationalCapacity: values.containerMinOperationalCapacity,
                        containerOperationalCapacity: values.containerOperationalCapacity,
                        containerUsefulCapacity: values.containerUsefulCapacity,
                        containerFundingCapacity: values.containerFundingCapacity,
                        containerHeelGasCapacity: values.containerHeelGasCapacity,
                        containerDuctDiameter: container.containerDuctDiameter,
                        containerKey: container.containerKey,
                        containerCode: container.containerCode,
                        containerStatus: container.containerStatus,
                        containerType: container.containerType,
                        gauges: null
                    };
                    dispensaryServices.put('container', filters)
                        .then(response => {
                            this.props.onDeleteContainers();
                        });
                    this.setState({
                        visible: false,
                        wasEdited: false,
                    });
                }
            });
        }

        showDeleteConfirm = (containerKey, containerId) => {
            confirm({
                title: `¿Está seguro que desea eliminar el contenedor ${containerKey}?`,
                content: 'Se perderán los datos del medidor permanentemente',
                okText: 'Sí',
                okType: 'danger',
                cancelText: 'No',
                centered: true,
                onOk: () => new Promise((resolve) => {
                    setTimeout(() => resolve(this.deleteContainer(containerId)), 2000);
                }).catch(() => console.log('error')),
                onCancel() {},
            });
        }

        showEditConfirm = ({ containerKey, integrationCode }) => {
            this.props.form.validateFieldsAndScroll((err, values) => {
                const titleConfirm = integrationCode !== values.integrationCode
                    ? `¿Está seguro que desea editar el contenedor ${containerKey} y cambiar el código de integración de ${integrationCode} a ${values.integrationCode}?`
                    : `¿Está seguro que desea editar el contenedor ${containerKey}?`;
                const messageConfirm = integrationCode !== values.integrationCode
                    ? 'Todas las nuevas mediciones serán asociadas a este contenedor y las mediciones previas a este cambio no se moverán ni se serán afectadas'
                    : 'Se perderán los datos del medidor';
                if (!err) {
                    confirm({
                        title: titleConfirm,
                        content: messageConfirm,
                        okText: 'Sí',
                        okType: 'danger',
                        cancelText: 'No',
                        centered: true,
                        onOk: () => new Promise((resolve) => {
                            setTimeout(() => resolve(this.editContainer()), 2000);
                        }).catch(() => console.log('error')),
                        onCancel() {},
                    });
                }
            });
        }

        onchangeIntegrationCode = (event, preValue) => {
            const integrationCode = event.target.value;
            this.setState({ integrationCodeVS: {} });
            if (integrationCode === preValue) {
                return;
            }
            const params = {
                integrationCode
            };
            this.setState({ integrationCodeUpdated: integrationCode });
            dispensaryServices.get('container/integration-code/exists', params)
                .then(response => {
                    if (response === true) {
                        this.setState({
                            integrationCodeVS: {
                                ...this.validateIntegrationCode(integrationCode),
                            }
                        });
                    }
                    this.setState({ integrationCodeExist: response });
                });
            this.editFields();
        }

        validateIntegrationCode = (integrationCode) => ({
            validateStatus: 'error',
            errorMsg: `El código de integración ${integrationCode} ya existe actualmente.`,
        })

        render() {
            const { container, integrationCodeVS } = this.state;
            const { containerId, pagePermissions } = this.props;
            const { getFieldDecorator } = this.props.form;

            return (
                <div style={{ display: 'inline-block' }} >
                    <Popover content={pagePermissions.edit ? 'Editar contenedor' : 'Ver información de contenedor'}>
                        <a type="link" shape="circle" onClick={() => this.showModal(containerId)}>
                            <LegacyIcon type={pagePermissions.edit ? 'edit' : 'info-circle'} theme="twoTone" style={{ fontSize: '20px' }} />
                        </a>
                    </Popover>
                    <Modal
                        open={this.state.visible}
                        title="Información del contenedor"
                        onCancel={this.handleReturn}
                        footer={pagePermissions.edit ? [
                            <Button type="danger" onClick={() => this.showDeleteConfirm(container.containerKey, container.idContainer)} key={0}>Eliminar</Button>,
                            this.state.wasEdited === false ?
                                <Button onClick={this.handleReturn} key={1}>Volver</Button> :
                                <Button type="primary" onClick={() => this.showEditConfirm(container)} key={2}>Editar</Button>
                        ] : []}
                    >
                        <p>A continuación se muestra la información detallada del contenedor.</p>
                        <Form layout='vertical'>
                            <Row gutter={24}>
                                <Col span={24}>
                                    <Form.Item label="Tipo de contenedor">
                                        <Input className="common-input"
                                               defaultValue={container.containerType}
                                               addonAfter={<Popover content={tooltip.tipoContenedor} trigger="click"><InfoCircleFilled/></Popover>}
                                               disabled />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={24}>
                                <Col span={12}>
                                    <Form.Item label="Clave de identificación">
                                        <Input className="common-input"
                                               defaultValue={container.containerKey}
                                               addonAfter={<Popover content={tooltip.tanques.claveInstalacion} trigger="click"><InfoCircleFilled/></Popover>}
                                               disabled />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={24}>
                                <Col span={12}>
                                    <Form.Item label="Capacidad total">
                                        {getFieldDecorator('containerTotalCapacity', {
                                            initialValue: container.containerTotalCapacity,
                                        })(
                                            <InputNumber
                                                className="common-input"
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                style={{ width: '100%' }}
                                                disabled={!pagePermissions.edit}
                                                addonAfter={<Popover content={tooltip.tanques.capacidadTotal} trigger="click"><InfoCircleFilled/></Popover>}
                                                onChange={this.editFields}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="Volumen mínimo de operación">
                                        {getFieldDecorator('containerMinOperationalCapacity', {
                                            initialValue: container.containerMinOperationalCapacity,
                                        })(
                                            <InputNumber
                                                className="common-input"
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                style={{ width: '100%' }}
                                                disabled={!pagePermissions.edit}
                                                addonAfter={<Popover content={tooltip.tanques.nivelMinimoOperativo} trigger="click"><InfoCircleFilled/></Popover>}
                                                onChange={this.editFields}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={24}>
                                <Col span={12}>
                                    <Form.Item label="Capacidad operativa">
                                        {getFieldDecorator('containerOperationalCapacity', {
                                            initialValue: container.containerOperationalCapacity,
                                        })(
                                            <InputNumber
                                                className="common-input"
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                style={{ width: '100%' }}
                                                disabled={!pagePermissions.edit}
                                                addonAfter={<Popover content={tooltip.tanques.capacidadOperativa} trigger="click"><InfoCircleFilled/></Popover>}
                                                onChange={this.editFields}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="Capacidad útil">
                                        {getFieldDecorator('containerUsefulCapacity', {
                                            initialValue: container.containerUsefulCapacity,
                                        })(
                                            <InputNumber
                                                className="common-input"
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                style={{ width: '100%' }}
                                                disabled={!pagePermissions.edit}
                                                addonAfter={<Popover content={tooltip.tanques.capacidadUtil} trigger="click"><InfoCircleFilled/></Popover>}
                                                onChange={this.editFields}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={24}>
                                <Col span={12}>
                                    <Form.Item label="Capacidad fondaje">
                                        {getFieldDecorator('containerFundingCapacity', {
                                            initialValue: container.containerFundingCapacity,
                                        })(
                                            <InputNumber
                                                className="common-input"
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                style={{ width: '100%' }}
                                                disabled={!pagePermissions.edit}
                                                addonAfter={<Popover content={tooltip.tanques.capacidadFondaje} trigger="click"><InfoCircleFilled/></Popover>}
                                                onChange={this.editFields}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="Capacidad gas talón">
                                        {getFieldDecorator('containerHeelGasCapacity', {
                                            initialValue: container.containerHeelGasCapacity,
                                        })(
                                            <InputNumber
                                                className="common-input"
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                style={{ width: '100%' }}
                                                disabled={!pagePermissions.edit}
                                                addonAfter={<Popover content={tooltip.nivelMinimoLlenado} trigger="click"><InfoCircleFilled/></Popover>}
                                                onChange={this.editFields}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={24}>
                                <Col span={12}>
                                    <Form.Item label="Tipo de producto">
                                        {getFieldDecorator('idProduct', {
                                            initialValue: (container.product || {}).productCode + ' - ' + (container.product || {}).productDescription,
                                        })(
                                            <Input className="common-input"
                                                   addonAfter={<Popover content={tooltipWarehouse.tipoProducto} trigger="click"><InfoCircleFilled/></Popover>}
                                                   disabled />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="Tipo de subproducto">
                                        {getFieldDecorator('idSubproduct', {
                                            initialValue: (container.subproduct || {}).code + ' - ' + (container.subproduct || {}).description,
                                        })(
                                            <Input className="common-input"
                                                   addonAfter={<Popover content={tooltipWarehouse.tipoSubProducto} trigger="click"><InfoCircleFilled/></Popover>}
                                                   disabled />
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={24}>
                                <Col span={24}>
                                    <Tooltip title={tooltip.tanques.calibracion}>
                                        <Form.Item label="Vigencia de calibración">
                                            {getFieldDecorator('containerCalibrationDate', {
                                                initialValue: container.containerCalibrationDate !== null ? dayjs(container.containerCalibrationDate) : null,
                                            })(
                                                <DatePicker
                                                    lang='es'
                                                    style={{ width: '100%' }}
                                                    disabled={!pagePermissions.edit}
                                                    format="DD-MM-YYYY"
                                                    onChange={this.editFields}
                                                />
                                            )}
                                        </Form.Item>
                                    </Tooltip>
                                </Col>
                            </Row>

                            <Row gutter={24}>
                                <Col span={24}>
                                    <Tooltip title={tooltip.tanques.descripcion}>
                                        <Form.Item label="Localización y descripción">
                                            {getFieldDecorator('containerDescription', {
                                                initialValue: container.containerDescription,
                                                rules: [{ required: true, message: 'Por favor introduce la localización y/o descripción del contenedor' }],
                                            })(
                                                <TextArea autoSize={{ minRows: 1, maxRows: 6 }} disabled={!pagePermissions.edit} onChange={this.editFields} />
                                            )}
                                        </Form.Item>
                                    </Tooltip>
                                </Col>
                            </Row>

                            <Row gutter={24}>
                                <Col span={24}>
                                    <Form.Item
                                        label="Código de integración"
                                        validateStatus={integrationCodeVS.validateStatus}
                                        help={integrationCodeVS.errorMsg}
                                    >
                                        {getFieldDecorator('integrationCode', {
                                            initialValue: container.integrationCode,
                                        })(
                                            <Input onChange={e => this.onchangeIntegrationCode(e, container.integrationCode)}
                                                   addonAfter={<Popover content={tooltip.codigoIntegracion} trigger="click"><InfoCircleFilled/></Popover>}
                                                   disabled={!pagePermissions.edit} />
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Modal>
                </div>
            );
        }
    }
);

const mapStateToProps = ({ userData, userData: { permissions } }) => ({
    userData,
    pagePermissions: getPagePermissions(DISPENSARY_PERMISSION, permissions)
});

export default connect(mapStateToProps)(ContainerShowInfo);
